/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from "react";
import { getTeeTimes } from "../services/firebase";

function useTeeTimes(eventId) {
  const [teeTimes, setTeeTimes] = useState([]);

  useEffect(() => {
    if (eventId) {
      const unsubscribe = getTeeTimes(eventId, setTeeTimes);
      return () => {
        unsubscribe();
      };
    }
    return () => {};
  }, [eventId]);

  return teeTimes;
}

export { useTeeTimes };
